import './components/share'

import './scss/st15/styles.scss'
